import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleSnackBar } from 'apps/auth/actions/appAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { DetailsItem } from 'apps/auth/components/common/DetailsItem/DetailsItem';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import {
    AF_NOTIFY_RECIPIENT_SCREEN_SHOWN,
    AF_RECIPIENT_VERIFICATION_LINK_COPY_CLICKED,
    SHARE_DETAILS_CLICKED,
} from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { SCENARIO_ID } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { canShareDetails, copyTextToClipboard, shareDetails } from 'apps/auth/helpers/utils';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const AntifraudRecipientNotifyModal = (props) => {
    const { shareTitleDetails, notifyHeader, antifraudNotifySubheader, interacNotifyCopyCode, antifraudUrlLabel, shareDetailsLink, copied } = usePageMessages();
    const extra = props.extra;

    useEffect(() => {
        amplitude.getInstance().logEvent(AF_NOTIFY_RECIPIENT_SCREEN_SHOWN, { [SCENARIO_ID]: extra?.fraudScenarioId });
    }, []);

    const copyButtonClick = (textToCopy, messageSnackBar) => {
        return () => {
            amplitude.getInstance().logEvent(AF_RECIPIENT_VERIFICATION_LINK_COPY_CLICKED, { [SCENARIO_ID]: extra?.fraudScenarioId });
            const result = copyTextToClipboard(textToCopy);
            if (result) {
                props.toggleSnackBar(true, messageSnackBar);
            }
        };
    };

    const getUrl = (addProtocol = false) => {
        const continueButtonLink = extra?.continueButtonLink ?? '';
        if (addProtocol) {
            return continueButtonLink;
        }

        return continueButtonLink.replace(/^https?:\/\//, '');
    };

    const getMessageForSnackBar = (title, copied) => `${title} ${copied}`;

    return (
        <ModalComponent>
            <HeaderPanel title={notifyHeader} subtitle={antifraudNotifySubheader} />
            <Row indent="adaptive-32-48">
                <DetailsItem
                    detailsTitle={antifraudUrlLabel}
                    detailsText={getUrl()}
                    detailsButton={interacNotifyCopyCode}
                    detailsButtonClick={copyButtonClick(getUrl(true), getMessageForSnackBar(antifraudUrlLabel, copied))}
                />
            </Row>
            {canShareDetails() && (
                <Button
                    type="button"
                    variant="row"
                    size="tight"
                    caption={shareDetailsLink}
                    negativeMargin
                    onClick={(e) => {
                        e.preventDefault();
                        amplitude.getInstance().logEvent(SHARE_DETAILS_CLICKED);
                        shareDetails(`${shareTitleDetails}`, `${props.shareDetails}`);
                    }}
                />
            )}
        </ModalComponent>
    );
};

export default connect(null, { toggleSnackBar })(AntifraudRecipientNotifyModal);
